import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const Blog = createApi({
  reducerPath: "Blog",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://api.anclatechs.com/",
    // baseUrl: "http://localhost:8000",
  }),
  endpoints: (builder) => ({
    getBlogList: builder.query({
      query: (page = 1) => `/blog/list?page=${page}`,
    }),
    getBlogByCategoryList: builder.query({
      query: (slug) => `/blog/list?category__name=${slug}&page=1`,
    }),
    getCategoryList: builder.query({
      query: (page = 1) => `/blog/category?page=${page}`,
    }),
    getFeaturedList: builder.query({
      query: (page = 1) => `/blog/featured?page=${page}`,
    }),
    getBlogBySlug: builder.query({
      query: (slug) => `/blog/${slug}`,
    }),
    getRelatedBlogBySlug: builder.query({
      query: (slug) => `/blog/related/${slug}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetBlogBySlugQuery, useGetBlogListQuery, useGetRelatedBlogBySlugQuery, useGetCategoryListQuery, useGetFeaturedListQuery, useGetBlogByCategoryListQuery } = Blog;
